import React from 'react'
import styles from './home.module.css'
import Section from '../../Components/Section/Section'
import ServiceCard from '../../Components/ServiceCard/ServiceCard'


function Services() {
    const services = [
        {
            title: 'Manicures',
            description: 'Natural nail care and polished finishes',
            price: '25',
            options: ['Structured Gel Manicure', 'Acrylic Overlay', 'Gel Manicure', 'Traditional Manicure']
        },
        {
            title: 'Extensions',
            description: 'Custom lengths, shapes, and finishes',
            price: '45',
            options: ['Acrylic Full set', 'Hard Gel Extensions']
        },
        {
            title: 'Pedicures',
            description: 'A little extra care from heel to toe',
            price: '30',
            options: ['Classic Pedicure', 'Gel Pedicure', 'Spa Pedicure']
        },
        {
            title: 'Fills & Repairs',
            description: 'Maintenance and a little extra attention',
            price: '10',
            options: [
                'Acrylic Fill-In',
                'Hard Gel Fill-In',
                'Structured Gel Rebalance',
                'Acrylic Repair',
                'Hard and Soft Gel Repair'
            ]
        },
        {
            title: 'Removals',
            description: 'Gentle removal for a fresh start',
            price: '15',
            options: ['Gel Polish Removal', 'Acrylic Soak Off', 'Soft Gel Soak Off']
        }
    ].map((service) => ({ ...service, cta: `Book ${service.title}` }))
    return (
        <Section id="services" shrink>
            <div className={styles.servicesContainer}>
                <div data-reveal className={styles.homeHeaderContainer} style={{ textAlign: "center"}}>
                    <h2 className={styles.smallHeader}>My Services</h2>
                    <h1 className={styles.largeHeader}>Find the best fit for you.</h1>
                </div>
                <div className={styles.servicesGrid}>
                    {services.map((service, index) => (
                        <div data-reveal key={index} className={styles.revealItem}>
                            <ServiceCard {...service} />
                        </div>
                    ))}
                </div>
            </div>

        </Section>
    )
}

export default Services
